<template>
    <div class="col-sm-12">
        <div class="card">
            <div class="card-body">
                <div class="form theme-form">
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label>Login <span v-if="! isEdit" class="red-asterisk">*</span></label>
                                <input
                                    v-model="username"
                                    class="form-control input-air-primary"
                                    type="text"
                                    :disabled="isEdit"
                                    :class="{'is-invalid': errors.username}"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <SelectBox
                                label="Role"
                                selectId="roles"
                                :items="roles"
                                :itemKey="role => role.id"
                                :itemValue="role => role.id"
                                :itemLabel="role => role.name"
                                v-model:selectedValue="selectedRole"
                                :wrapperClass="'mb-3'"
                                :placeholder="'Select a role'"
                                :class="{'is-invalid': errors.role}"
                            />
                        </div>
                    </div>
                    <div v-if="selectedRoleName === 'user'" class="row">
                        <div class="col">
                            <SelectBox
                                label="Specialization"
                                selectId="specializations"
                                :items="specializations"
                                :itemKey="specialization => specialization.id"
                                :itemValue="specialization => specialization.id"
                                :itemLabel="specialization => specialization.name"
                                v-model:selectedValue="selectedSpecialization"
                                :wrapperClass="'mb-3'"
                                :placeholder="'Select a specialization'"
                                :class="{'is-invalid': errors.specialization_id}"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label>Name</label>
                                <input
                                    v-model="name"
                                    class="form-control input-air-primary"
                                    type="text"
                                    :class="{'is-invalid': errors.name}"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label>Password <span v-if="!isEdit" class="red-asterisk">*</span></label>
                                <input
                                    v-model="password"
                                    class="form-control input-air-primary"
                                    type="password"
                                    :placeholder="isEdit ? 'Leave blank to keep current password' : ''"
                                    :class="{'is-invalid': errors.password}"
                                >
                            </div>
                        </div>
                    </div>
                    <label v-if="!hideProjectSelect" class="form-label" for="projects">Project</label>
                    <select v-if="!hideProjectSelect" v-model="selectedProject" class="form-select input-air-primary digits" id="projects">
                        <option
                            v-for="project in projects"
                            :key="project.id"
                            :value="project.id">{{ project.project_title }}
                        </option>
                    </select>
                    <div v-if="showButtons" class="row">
                        <div class="col">
                            <div class="text-end">
                                <a class="btn btn-success me-3" target="_blank" @click="store()"> {{ isEdit ? 'Save' : 'Store' }}</a>
                                <a class="btn btn-danger" @click="clearForm">Cancel</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <alert-loading :loading="loading"></alert-loading>
</template>

<script>
import AlertLoading from "../Basic/AlertLoading.vue";
import SelectBox from "../Basic/Forms/SelectBox.vue";

const { createToaster } = require('@meforma/vue-toaster');
const toaster = createToaster({})

export default {
    name: 'CreateUser',
    components: { SelectBox, AlertLoading },
    emits: ['stored', 'closeModal'],
    data() {
        return {
            loading: false,
            errors: {},
            inputClasses: "",
            roles: [],
            projects: [],
            specializations: [],
            username: null,
            password: null,
            email: null,
            name: null,
            selectedRole: null,
            selectedProject: null,
            selectedRoleName: null,
            selectedSpecialization: null,
            hideProjectSelect: true,
        };
    },
    props: {
        isEdit: {
            default: false,
        },
        showButtons: {
            default: false,
        },
        user: {
            default: {},
        },
    },
    watch: {
        user: function (newVal) {
            if (this.isEdit) {
                console.log(newVal.projects);

                this.username = newVal.username;
                this.email = newVal.email;
                this.name = newVal.name;

                if (newVal.roles && newVal.roles.length > 0) {
                    this.selectRole(newVal.roles[0].id);
                }

                if (newVal.projects && newVal.projects.length > 0) {
                    this.selectProject(newVal.projects[0].id);
                }

                if (newVal.specialization) {
                    this.selectedSpecialization = newVal.specialization.id;
                }

                this.validated();
            }
        },
        selectedRole(roleId) {
            const selectedRole = this.roles.find(role => role.id === +roleId);
            this.selectedRoleName = selectedRole ? selectedRole.name.toLowerCase() : null;

            if (this.selectedRoleName !== 'user') {
                this.selectedSpecialization = null;
            }
        },
    },
    methods: {
        initialState() {
            return {
                errors: {},
                inputClasses: "",
                username: null,
                password: null,
                email: null,
                name: null,
                selectedRole: null,
                selectedProject: null,
            }
        },
        validated: function () {
            if (this.username === undefined || this.username === null || this.username.length < 4) {
                this.inputClasses = 'is-invalid'
            } else {
                this.inputClasses = 'is-valid'
            }
        },

        clearForm() {
            Object.assign(this.$data, this.initialState());
        },

        isValidForm() {
            this.errors = {};
            if (this.username === undefined || this.username === null || this.username.length < 4) {
                this.errors.username = true;

                this.showToastErrorMessage('Username is incorrect.');
                return false;
            }

            return true;
        },

        getCreateUserData() {
            const userData = {
                name: this.name,
                role: +this.selectedRole,
                project: +this.selectedProject || null,
                specialization_id: this.selectedSpecialization,
                email: this.email || null,
            };

            if (!this.isEdit) {
                // Поля, необходимые только для создания
                userData.username = this.username;
                userData.password = this.password; // Пароль обязателен для создания
            } else if (this.password) {
                // Отправляем пароль только если он указан при редактировании
                userData.password = this.password;
            }

            return userData;
        },

        getRequestConfig(userData) {
            let url = '/api/users';
            let method = 'post';

            if (this.isEdit) {
                url += `/${this.user.id}`;
                method = 'put';
            }

            return { method, url, data: userData };
        },

        async handleSubmitSuccess(message) {
            this.showToastSuccessMessage(message);
            this.clearForm();

            this.$emit('closeModal');
            this.$emit('stored');
        },

        async handleSubmitError(errors, message) {
            this.errors = errors;
            Object.values(this.errors).flat().forEach(error => {
                this.showToastErrorMessage(`- ${error}`);
            });

            if (! errors && message) {
                this.showToastErrorMessage(message);
            }
        },

        async store() {
            if (!this.isValidForm()) return;
            let userData = this.getCreateUserData();
            let requestConfig = this.getRequestConfig(userData);

            try {
                let { data } = await axios(requestConfig);
                if (data.success) {
                    await this.handleSubmitSuccess(data.message);
                } else {
                    this.showToastErrorMessage(data.message);
                }
            } catch (error) {
                if (error.response) {
                    await this.handleSubmitError(error.response.data.errors, error.response.data.message);
                }
            }
        },

        showToastErrorMessage(message) {
            toaster.show('Opps... ' + message, { theme: 'outline', position: 'top-right', icon: 'times', type: 'error', duration: 2000 });
        },

        showToastSuccessMessage(message) {
            toaster.show(message, { theme: 'outline', position: 'top-right', icon: 'times', type: 'success', duration: 2000 });
        },

        async getFormData() {
            try {
                const { data } = await axios.get('/api/users/get-form-data');
                this.roles = data.items.roles;
                this.projects = data.items.projects;
                this.specializations = data.items.specializations;
            } catch (error) {
                this.showToastErrorMessage(error.message || 'Failed to fetch data');
            }
        },

        selectRole(roleId) {
            const newRole = this.user.roles[0];
            let role = this.roles.find(r => r.id === roleId);

            if (!role && newRole) {
                this.roles.push(newRole);
                role = newRole;
            }

            this.selectedRole = role ? role.id : null;
        },

        selectProject(projectId) {
            const newRole = this.user.projects[0];
            let project = this.projects.find(r => r.id === projectId);

            if (!project && newRole) {
                this.projects.push(newRole);
                project = newRole;
            }

            this.selectedProject = project ? project.id : null;
        },

        /** ToDo: Used for call with loading spinner */
        async onOpen() {
            this.loading = true;
            try {
                await this.getFormData();

                if (this.isEdit) {
                    this.selectRole(this.user.roles[0].id);
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.showToastErrorMessage(error.message || 'Failed to fetch roles');
            }
        },
    },
    mounted() {
        this.getFormData();
    }
}
</script>

<style scoped>
.red-asterisk {
    color: red;
}

input:disabled,
select:disabled {
    background-color: #f9f9f9;
    cursor: not-allowed;
}
</style>
